import { Component, OnInit } from "@angular/core";
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;

@Component({
  selector: "appstore-badges",
  templateUrl: "./appstore-badges.component.html",
  styleUrls: ["./appstore-badges.component.scss"]
})
export class AppstoreBadgesComponent implements OnInit {
  displayAppStore = false;

  constructor() {
    Device.getInfo().then(deviceInfo => {
      if (deviceInfo.platform == "web") {
        this.displayAppStore = true;
      }
    });
  }

  ngOnInit() {}

  openPlayStore(){
    window.open("https://play.google.com/store/apps/details?id=com.latourneedesproducteurs", "_blank");
  }
  openAppleStore(){
    window.open("https://apps.apple.com/us/app/la-tournée-des-producteurs/id1511406664", "_blank");
  }
}
